/** @type {import('next-i18next').UserConfig} */

/**
 * NOTE: Can't import the constants here since our constants are in typescript.
 * Using hardcoded values below based on the constants in src/config/i18n.config.ts
 */
module.exports =
  process.env.NEXT_PUBLIC_ENABLE_I18N === 'true'
    ? {
        i18n: {
          /**
           * ISSUE: There is no way to differentiate between path without locale and path with default locale.
           * So we are using 'default' as default locale that points to 'en-US' locale in app.
           *
           * TODO: Find a better solution to handle this.
           */
          defaultLocale: 'default-locale',
          locales: ['default-locale', 'us', 'ca', 'us-en', 'us-es', 'ca-en', 'ca-fr'],
          localeDetection: false,
        },
        /**
         * NOTE: next-i18next looks for locale files with format lowercased lang, uppercased country as standard en-US.
         * but since we have US-en format - it doesn't work well. Make sure to use lowerCaseLng `true` to avoid issues.
         */
        lowerCaseLng: true,
        fallbackLng: 'us-en',
        localePath: './public/locales',
        localeStructure: '{{lng}}/{{ns}}',
        reloadOnPrerender: process.env.NODE_ENV === 'development',
        serializeConfig: false,
        debug: process.env.NODE_ENV === 'development',
      }
    : undefined
